import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ShowContainer from "../ShowContainer";
import { Autoplay, Pagination, Navigation, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

/**
 *
 * @param {import("swiper/react").SwiperProps} props
 */
export default function CustomCarousel({ children, className = "", ...props }) {
  const isAutoWidth = (props.slidesPerView ?? "auto") === "auto";

  return (
    <ShowContainer condition={React.Children.count(children)}>
      <div className="custom__carousel">
        <Swiper
          slidesPerView="auto"
          spaceBetween={10}
          grabCursor
          // следим за появлением/изменением размера родителя (например, открытие
          // сайдбара/мобильного меню, где карусель до этого была скрыта/нулевой ширины) —
          // без этого Swiper запоминает размер на момент инициализации и не пересчитывает его,
          // из-за чего слайды могут получить кривую огромную инлайн-ширину (~2^24px)
          observer
          observeParents
          updateOnWindowResize
          {...props}
          className={className}
          modules={[Autoplay, Pagination, Navigation, FreeMode]}
          onSwiper={(swiper) => {
            // подстраховка: форсируем пересчёт сразу после маунта на случай,
            // если контейнер в этот момент уже видим, но что-то не успело измериться
            requestAnimationFrame(() => swiper?.update());
            props.onSwiper?.(swiper);
          }}>
          {React.Children.map(children, (child, index) => (
            <SwiperSlide
              key={index}
              className="carousel-item"
              style={isAutoWidth ? { width: "auto" } : undefined}>
              {child}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ShowContainer>
  );
}
